module.exports = __webpack_public_path__ + "static/media/logo.7458d104.jpg";